import { SimplyRoadmap } from '@/models/games/baccarat/Roadmap';
import { PokDengRoadmapRoundData } from '@/models/games/pokdeng/Roadmap';
import { getBeadRoadRecord as getPokDengBeadRoadRecord } from '@/modules/roadmap/pokdeng/util';
import { Epic } from 'redux-observable';
import { concat, filter, switchMap } from 'rxjs';
import { Roadmap, getEmptyRoadMap } from '../models/Roadmap';
import {
    BaccaratRecord,
    BaccaratSimplyRoadmap,
} from '../models/games/baccarat';
import { DragonTigerRecord } from '../models/games/dragonTiger';
import { GameType as CommonGameType } from '../models/games/enums/GameType';
import { SupportedRecord } from '../modules/host/models';
import { hostsSliceActions } from '../modules/host/slice';
import { ROAD_MAP_TYPE } from '../modules/lobby/constants';
import {
    getSummaryList as getBaccaratSummaryList,
    getBeadRoadRecord,
    getMappedRoad,
    getNextRoad,
    getOtherRoad,
} from '../modules/roadmap/baccarat/util';
import { getDTSummaryList } from '../modules/roadmap/dragonTiger/util';
import { getRoadmap, roadmapSliceActions } from '../modules/roadmap/slice';
import { RootState } from '../store/store';
export const GameTypeFullRoad = CommonGameType.Baccarat | CommonGameType.Dragon;
export const SupportedGameType = GameTypeFullRoad | CommonGameType.PokDeng;
export const roadmapEpic: Epic = (action$, store$) =>
    action$.pipe(
        filter(hostsSliceActions.updateRecord.match),
        switchMap(action => {
            const outs = [];
            const hostId = action.payload.hostId;
            const gameType = action.payload.gameType;
            console.log('epic::roadmap', gameType, hostId);
            if (gameType !== undefined)
                if ((GameTypeFullRoad & gameType) > 0) {
                    const rm: Roadmap<BaccaratSimplyRoadmap> =
                        getEmptyRoadMap<BaccaratSimplyRoadmap>(hostId);
                    let record = action.payload
                        .record as Array<SupportedRecord>;
                    // convert the dragon tiger result
                    if (gameType === CommonGameType.Dragon) {
                        record = record.map(r => {
                            const dtr = r as DragonTigerRecord;
                            const data = {} as BaccaratRecord;
                            data.gameID = dtr.gameID;
                            data.result = dtr.result;
                            data.shoes = dtr.shoes;
                            data.round = dtr.round;
                            data.tie = dtr.tie;
                            data.resultPoint = dtr.resultPoint;

                            data.playerWin = dtr.dragonWin;
                            data.playerPoint = dtr.dragonPoint;
                            data.bankerWin = dtr.tigerWin;
                            data.bankerPoint = dtr.tigerPoint;
                            return data;
                        });
                    }

                    const store = store$.value as unknown as RootState;
                    const storeRM = store
                        ? getRoadmap(store, hostId)
                        : undefined;
                    const {
                        BeadRoad,
                        Other,
                        BigRoad,
                        BigEyeRoad,
                        SmallRoad,
                        CockroachRoad,
                    } = storeRM ? storeRM : rm;
                    const lastGame =
                        BeadRoad.length > 0
                            ? (
                                  BeadRoad[
                                      BeadRoad.length - 1
                                  ] as BaccaratSimplyRoadmap
                              ).GameID
                            : 0;
                    const lastIdx = record.findIndex(
                        r => r.gameID === lastGame
                    );
                    const start = lastIdx + 1;
                    let bead = (
                        BeadRoad && lastIdx >= 0 ? BeadRoad.concat() : []
                    ) as Array<SimplyRoadmap>;
                    let other = (
                        Other && lastIdx >= 0 ? Other.concat() : []
                    ) as Array<Array<SimplyRoadmap>>;
                    let big = BigRoad && lastIdx >= 0 ? BigRoad.concat() : [];
                    let bigEye =
                        BigEyeRoad && lastIdx >= 0 ? BigEyeRoad.concat() : [];
                    let small =
                        SmallRoad && lastIdx >= 0 ? SmallRoad.concat() : [];
                    let cockroach =
                        CockroachRoad && lastIdx >= 0
                            ? CockroachRoad.concat()
                            : [];
                    for (let i = start; i < record.length; i++) {
                        const newBead = getBeadRoadRecord(record[i]);
                        bead.push(newBead);
                        let nextBigEye = getNextRoad(
                            other,
                            ROAD_MAP_TYPE.BIG_EYE_ROAD,
                            newBead.Win
                        );
                        let nextSmall = getNextRoad(
                            other,
                            ROAD_MAP_TYPE.SMALL_ROAD,
                            newBead.Win
                        );
                        let nextCockroach = getNextRoad(
                            other,
                            ROAD_MAP_TYPE.COCKROACH_ROAD,
                            newBead.Win
                        );
                        other = getOtherRoad(other, newBead);
                        big = getMappedRoad(
                            big as Array<SimplyRoadmap>,
                            newBead,
                            other[other.length - 1]
                        );
                        if (newBead.Win != 2) {
                            bigEye = getMappedRoad(
                                bigEye as Array<SimplyRoadmap>,
                                {
                                    Win: nextBigEye,
                                    SpaceNum: 0,
                                    IsLast: true,
                                    AskType: -1,
                                    GameID: newBead.GameID,
                                }
                            );
                            small = getMappedRoad(
                                small as Array<SimplyRoadmap>,
                                {
                                    Win: nextSmall,
                                    SpaceNum: 0,
                                    IsLast: true,
                                    AskType: -1,
                                    GameID: newBead.GameID,
                                }
                            );
                            cockroach = getMappedRoad(
                                cockroach as Array<SimplyRoadmap>,
                                {
                                    Win: nextCockroach,
                                    SpaceNum: 0,
                                    IsLast: true,
                                    AskType: -1,
                                    GameID: newBead.GameID,
                                }
                            );
                        }
                    }
                    rm.Other = other;
                    rm.BeadRoad = bead;
                    rm.BigRoad = big as Array<SimplyRoadmap>;
                    rm.SmallRoad = small as Array<SimplyRoadmap>;
                    rm.BigEyeRoad = bigEye as Array<SimplyRoadmap>;
                    rm.CockroachRoad = cockroach as Array<SimplyRoadmap>;

                    rm.NextBigEye = getNextRoad(
                        other,
                        ROAD_MAP_TYPE.BIG_EYE_ROAD,
                        1
                    );
                    rm.NextSmall = getNextRoad(
                        other,
                        ROAD_MAP_TYPE.SMALL_ROAD,
                        1
                    );
                    rm.NextCockroachRoad = getNextRoad(
                        other,
                        ROAD_MAP_TYPE.COCKROACH_ROAD,
                        1
                    );
                    console.log('epic::roadmap', rm);
                    switch (gameType) {
                        case CommonGameType.Baccarat:
                            rm.Summary = getBaccaratSummaryList(record);
                            break;
                        case CommonGameType.Dragon:
                            rm.Summary = getDTSummaryList(record);
                            break;
                    }
                    outs.push(roadmapSliceActions.update(rm));
                } else if (gameType === CommonGameType.PokDeng) {
                    const rm: Roadmap<PokDengRoadmapRoundData> =
                        getEmptyRoadMap<PokDengRoadmapRoundData>(hostId);
                    let record = action.payload
                        .record as Array<SupportedRecord>;
                    // convert the dragon tiger result
                    const store = store$.value as unknown as RootState;
                    const storeRM = store
                        ? getRoadmap(store, hostId)
                        : undefined;
                    const { BeadRoad } = storeRM ? storeRM : rm;
                    const lastGame =
                        BeadRoad.length > 0
                            ? (
                                  BeadRoad[
                                      BeadRoad.length - 1
                                  ] as PokDengRoadmapRoundData
                              ).GameID
                            : 0;
                    const lastIdx = record.findIndex(
                        r => r.gameID === lastGame
                    );
                    const start = lastIdx + 1;
                    let bead =
                        BeadRoad && lastIdx >= 0 ? BeadRoad.concat() : [];
                    for (let i = start; i < record.length; i++) {
                        const newBead = getPokDengBeadRoadRecord(record[i]);
                        if (newBead.Result.length > 0) bead.push(newBead);
                    }
                    rm.BeadRoad = bead as Array<PokDengRoadmapRoundData>;
                    outs.push(roadmapSliceActions.update(rm));
                }
            return concat(outs);
        })
    );
